// @flow
import * as React from 'react';

import { connect } from 'react-redux';

import CurrencyPipe from 'views/utils/pipes/CurrencyPipe';

import type { Affiliate } from 'affiliate';
import type { State as AffiliateBalanceState } from 'state/reducers/affiliateBalance';

type OwnProps = {||};

type Props = {
  ...OwnProps,
  value: $PropertyType<Affiliate, 'balance'>,
};

function AffiliateBalance({ value }: Props) {
  return <span>Balance: {CurrencyPipe(value)}</span>;
}

type State = {
  affiliateBalance: AffiliateBalanceState,
};

const mapStateToProps = ({ affiliateBalance }: State) => ({
  value: affiliateBalance.value,
});

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, {})(AffiliateBalance);
